import styles from './EditPriceTabItems.module.css';
import { Grid, ListItem, Tooltip } from '@mui/material';
import { StoreProduct } from '@/types/menus.types';
import { splitArray } from '@/services/menu/menus.helper.service';
import { TooltipContent, tooltipProps } from '../../StoreMenuDetails/internal/TooltipHelper';
import { AlertTriangle } from 'react-feather';
import { useTranslation } from 'react-i18next';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

type ProductItemProps = {
  variantId: string;
  productName: string;
  productDescription: string;
  priceLock: boolean;
  mandatoryProductLock: boolean;
  t: any;
};

const ProductItem: React.FC<ProductItemProps> = ({
  variantId,
  productName,
  productDescription,
  priceLock,
  mandatoryProductLock,
  t,
}) => {
  return (
    // <ListItem key={variantId}>
    <ListItem>
      <p>
        <li>
          <span className={styles.productsIncluded}>
            {productName}, {productDescription}
          </span>
          {mandatoryProductLock && (
            <Tooltip {...tooltipProps} title={<TooltipContent text={t('menuDetails.mandatoryAndNoDeactivation')} />}>
              <AlertTriangle className={styles.alertTriangle} size={16} color="#E6740A" />
            </Tooltip>
          )}
          {priceLock && (
            <Tooltip {...tooltipProps} title={<TooltipContent text={t('menuDetails.lockPriceAndNoChange')} />}>
              <LockOutlinedIcon
                className={styles.priceLockIcon}
                style={{ color: '#E6740A' }}
                data-testid="locked-icon"
                sx={{
                  width: '18px',
                  height: '18px',
                }}
              />
            </Tooltip>
          )}
        </li>
      </p>
    </ListItem>
  );
};
export const ProductsIncluded = ({ storeProducts }: { storeProducts: StoreProduct[] }) => {
  const { t } = useTranslation();
  const sortedProducts = storeProducts.sort(
    (a, b) => a.productName.localeCompare(b.productName) || a.productDescription.localeCompare(b.productDescription),
  );
  const [storeProductsOne, storeProductsTwo] = splitArray(sortedProducts);

  return (
    <>
      <div className={styles.productInfo}>Products Included</div>
      <Grid container direction="row" justifyContent="space-between" alignItems="left">
        <Grid item>
          {storeProductsOne.map((storeProduct) => (
            <ProductItem
              key={storeProduct.variantId}
              variantId={storeProduct.variantId}
              productName={storeProduct.productName}
              productDescription={storeProduct.productDescription}
              priceLock={storeProduct.priceLock}
              mandatoryProductLock={storeProduct.mandatoryProductLock}
              t={t}
            />
          ))}
        </Grid>
        <Grid item>
          {storeProductsTwo.map((storeProduct) => (
            <ProductItem
              key={storeProduct.variantId}
              variantId={storeProduct.variantId}
              productName={storeProduct.productName}
              productDescription={storeProduct.productDescription}
              priceLock={storeProduct.priceLock}
              mandatoryProductLock={storeProduct.mandatoryProductLock}
              t={t}
            />
          ))}
        </Grid>
      </Grid>
    </>
  );
};
